document.addEventListener('DOMContentLoaded', () => {
    /* ==========================================================
       VARIABLES
    ========================================================== */
    const body = document.body;
    const gallerySlides = [...document.querySelectorAll('.gallery-slide')];
    const galleryThumbs = [...document.querySelectorAll('.gallery-thumb')];
    const currentSlide = document.querySelector('.gallery-current');
    const totalSlides = document.querySelector('.gallery-total');
    const prevBtn = document.querySelector('.gallery-prev');
    const nextBtn = document.querySelector('.gallery-next');
    const quantityInput = document.querySelector('#quantity');
    const qtyMinus = document.querySelector('.qty-minus');
    const qtyPlus = document.querySelector('.qty-plus');
    const totalPrice = document.querySelector('#total-price');
    const addToCartBtn = document.querySelector('#roamlink-add-cart');
    const acknowledgementCheckboxes = document.querySelectorAll(
        '.acknowledgement-checkbox'
    );
 if (!document.querySelector('.roamlink-product')) {
    return;
}
    const productVariantInput = document.querySelector(
        'input[name="id"]'
    );
    const simSelector = document.querySelector('#sim-selector');
    const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: window.roamlinkProduct?.currency ?? 'USD'
});
    let currentIndex = 0;
    // SIM Variant mappings
    const ROAMLINK_SIM_VARIANTS = {
        esim: 50681440403755,
        physical: 50681431195947
    };
    /* ==========================================================
        GALLERY
    ========================================================== */
    function showSlide(index){
        if(index < 0){
            index = gallerySlides.length - 1;
        }
        if(index >= gallerySlides.length){
            index = 0;
        }
        currentIndex = index;
        gallerySlides.forEach(slide=>{
            slide.style.display='none';
            slide.classList.remove('active');
        });
        galleryThumbs.forEach(thumb=>{
            thumb.classList.remove('active');
        });
        if(gallerySlides[index]){
            gallerySlides[index].style.display='block';
            gallerySlides[index].classList.add('active');
        }
        if(galleryThumbs[index]){
            galleryThumbs[index].classList.add('active');
        }
        if(currentSlide){
            currentSlide.textContent=index+1;
        }
    }
    galleryThumbs.forEach((thumb,index)=>{
        thumb.addEventListener('click',()=>{
            showSlide(index);
        });
    });
    if(prevBtn){
        prevBtn.addEventListener('click',()=>{
            showSlide(currentIndex-1);
        });
    }
    if(nextBtn){
        nextBtn.addEventListener('click',()=>{
            showSlide(currentIndex+1);
        });
    }
    if(totalSlides){
        totalSlides.textContent=gallerySlides.length;
    }
    showSlide(0);
    /* ==========================================================
       PLAN ACCORDION
       PLAN ACCORDION (UNMODIFIED)
    ========================================================== */
    document.querySelectorAll('.plan-group-header').forEach(header=>{
        header.addEventListener('click',()=>{
            const group=header.closest('.plan-group');
            const groupBody = group.querySelector('.plan-group-body');
            const opened=group.classList.contains('is-open');
            document.querySelectorAll('.plan-group').forEach(item=>{
                item.classList.remove('is-open');
                const content=item.querySelector('.plan-group-body');
                const icon=item.querySelector('.accordion-icon');
                if(content){
                    content.hidden=true;
                }
                if(icon){
                    icon.textContent='+';
                }
            });
            if(!opened){
                group.classList.add('is-open');
                groupBody.hidden = false;
                const icon=group.querySelector('.accordion-icon');
                if(icon){
                    icon.textContent='−';
                }
                // // Auto-select first plan inside newly opened group if none checked
                // const checkedRadio = groupBody.querySelector('input[name="roamlink-plan"]:checked');
                // if (!checkedRadio) {
                //     const firstRadio = groupBody.querySelector('input[name="roamlink-plan"]');
                //     if (firstRadio) {
                //         firstRadio.checked = true;
                //         firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
                //     }
                // }
            }
            
            toggleSimUI();
        });
    });
    /* ==========================================================
       QUANTITY
    ========================================================== */
    if(qtyMinus){
        qtyMinus.addEventListener('click',()=>{
            let value=parseInt(quantityInput.value)||1;
            value--;
            if(value<1){
                value=1;
            }
            quantityInput.value=value;
            calculateTotal();
        });
    }
    if(qtyPlus){
        qtyPlus.addEventListener('click',()=>{
            let value=parseInt(quantityInput.value)||1;
            value++;
            quantityInput.value=value;
            calculateTotal();
        });
    }
   
    /* ==========================================================
       LIVE PRICE
    ========================================================== */
    function calculateTotal() {
        // let total = Number(window.roamlinkProduct?.basePrice || 0);
        let total = 0;
        const quantity = Math.max(
            parseInt(quantityInput?.value || 1, 10),
            1
        );
        // Selected Plan
        const selectedPlan = document.querySelector(
    'input[name="roamlink-plan"]:checked'
);





if (selectedPlan) {
    // User selected another plan
    total += Number(selectedPlan.dataset.price || 0);
} else {
    // Use current PDP plan
    total += Number(window.roamlinkProduct.basePrice || 0);
}
        // Selected Device
        const selectedDevice = document.querySelector(
            'input[name="roamlink-device"]:checked'
        );
        if (selectedDevice) {
            total += Number(selectedDevice.dataset.price || 0);
        }
        // Selected Addons
        const checkedAddons = document.querySelectorAll(
    'input[name="roamlink-addon"]:checked'
);

console.log('Checked Addons:', checkedAddons);
        document.querySelectorAll(
            'input[name="roamlink-addon"]:checked'
        ).forEach(addon => {
            console.log(
    'Addon Variant:',
    addon.value,
    addon.dataset.price
);
            total += Number(addon.dataset.price || 0);

        });
        total *= quantity;
      const currency = window.roamlinkProduct?.currency ?? 'USD';

// const formatter = new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency
// });

const buttonTotalPrice = document.querySelector('#button-total-price');

if (buttonTotalPrice) {
    buttonTotalPrice.textContent = formatter.format(total / 100);

}
const topPrice = document.getElementById('total-price');

if (topPrice) {

    const selectedPlan = document.querySelector(
        'input[name="roamlink-plan"]:checked'
    );

    const planPrice = selectedPlan
        ? Number(selectedPlan.dataset.price || 0)
        : Number(window.roamlinkProduct.basePrice || 0);

    topPrice.textContent = formatter.format(planPrice / 100);
}


    }
    /* ==========================================================
       SIM VISIBILITY CONTROL
    ========================================================== */
  function toggleSimUI() {

    if (!simSelector) return;

    const selectedPlan = document.querySelector(
        'input[name="roamlink-plan"]:checked'
    );

    const currentProductRequiresSim =
        window.roamlinkProduct.requiresSim === true;

    const selectedPlanRequiresSim =
        selectedPlan
            ? selectedPlan.dataset.requiresSim === "true"
            : false;

    const requiresSim =
        currentProductRequiresSim || selectedPlanRequiresSim;

    if (requiresSim) {

        simSelector.classList.remove('hide');

    } else {

        simSelector.classList.add('hide');

        document.querySelectorAll(
            'input[name="properties[SIM Type]"]'
        ).forEach(radio => {
            radio.checked = false;
        });

        updateSelectedCards();
    }
}
    /* ==========================================================
       UPDATE SELECTED CARDS
    ========================================================== */
    function updateSelectedCards() {
        // Plans
        document.querySelectorAll('.plan-card').forEach(card => {
            const input = card.querySelector('input[type="radio"]');
            card.classList.toggle('is-selected', input && input.checked);
        });
        // Devices
        document.querySelectorAll('.device-card').forEach(card => {
            const input = card.querySelector('input[type="radio"]');
            card.classList.toggle('is-selected', input && input.checked);
        });
        // Addons
        document.querySelectorAll('.addon-card').forEach(card => {
            const input = card.querySelector('input[type="checkbox"]');
            card.classList.toggle('is-selected', input && input.checked);
        });
        // SIM Types
        document.querySelectorAll('.sim-option').forEach(card => {
            const input = card.querySelector('input[type="radio"]');
            card.classList.toggle('is-selected', input && input.checked);
        });
    }
    /* ==========================================================
       OPTION CHANGES
    ========================================================== */
    document.querySelectorAll(
    '.plan-card input, .device-card input, .addon-card input, input[name="properties[SIM Type]"]'

    ).forEach(input => {
        input.addEventListener('change', () => {
            updateSelectedCards();
            calculateTotal();


if (input.name === 'properties[SIM Type]') {

    const simBody = document.querySelector('.sim-delivery-section-body');
    const deviceBody = document.querySelector('.device-section-body');

    const simHeading = document.querySelector('.roamlink-sim-delivery .section-heading');
    const deviceHeading = document.querySelector('.roamlink-devices .device-section-heading');

    // Close SIM
    simBody.hidden = true;
    simHeading?.setAttribute('aria-expanded', 'false');
    document
    .querySelector('.roamlink-sim-delivery')
    ?.classList.remove('is-open');

    // Open Devices
    deviceBody.hidden = false;
    deviceHeading?.setAttribute('aria-expanded', 'true');
    document
    .querySelector('.roamlink-devices')
    ?.classList.add('is-open');

}


            if (input.name === 'roamlink-plan') {

    toggleSimUI();


const planBody = document.querySelector('.plan-section-body');
const simBody = document.querySelector('.sim-delivery-section-body');
const deviceBody = document.querySelector('.device-section-body');

const planHeading = document.querySelector('.roamlink-plans .section-heading');
const simHeading = document.querySelector('.roamlink-sim-delivery .section-heading');
const deviceHeading = document.querySelector('.roamlink-devices .device-section-heading');

const simRequired =
    window.roamlinkProduct.requiresSim === true ||
    input.dataset.requiresSim === "true";

// Close Plans
planBody.hidden = true;
planHeading?.setAttribute('aria-expanded', 'false');

document
    .querySelector('.roamlink-plans')
    ?.classList.remove('is-open');
// Open next section
if (simRequired) {

   if (simBody) simBody.hidden = false;
    simHeading?.setAttribute('aria-expanded', 'true');
    document
        .querySelector('.roamlink-sim-delivery')
        ?.classList.add('is-open');   



} else {

    deviceBody.hidden = false;
    deviceHeading?.setAttribute('aria-expanded', 'true');
    document
    .querySelector('.roamlink-devices')
    ?.classList.add('is-open');

}



    

    const title = document.getElementById('product-title');

    if (title && input.dataset.productTitle) {
        title.textContent = input.dataset.productTitle;



const topPrice = document.getElementById('total-price');
const comparePrice = document.querySelector('.compare-price');

if (topPrice) {
    topPrice.textContent = formatter.format(
        Number(input.dataset.price) / 100
    );
}

if (comparePrice) {

    const compare = Number(input.dataset.comparePrice || 0);

    comparePrice.textContent =
        compare > Number(input.dataset.price)
            ? formatter.format(compare / 100)
            : '';
}



    }

    if (input.dataset.productHandle) {
        const url = new URL(window.location);
        url.searchParams.set('plan', input.dataset.productHandle);
        window.history.replaceState({}, '', url);
    }
}



if (input.name === 'roamlink-device') {

    const deviceBody = document.querySelector('.device-section-body');
    const deviceHeading = document.querySelector(
        '.roamlink-devices .device-section-heading'
    );

    // Close Devices
    deviceBody.hidden = true;
    deviceHeading?.setAttribute('aria-expanded', 'false');
    document
    .querySelector('.roamlink-devices')
    ?.classList.remove('is-open');
}



        });
    });
    /* ==========================================================
       CARD CLICK SUPPORT
    ========================================================== */
    // Plans
    document.querySelectorAll('.plan-card').forEach(card => {
        card.addEventListener('click', e => {
            if (e.target.tagName === 'INPUT') return;
            const input = card.querySelector('input');
            if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });
    // Devices
    document.querySelectorAll('.device-card').forEach(card => {
        card.addEventListener('click', e => {
            if (e.target.tagName === 'INPUT') return;
            const input = card.querySelector('input');
            if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });
    // Addons
    // document.querySelectorAll('.addon-card').forEach(card => {
    //     card.addEventListener('click', e => {
    //         if (e.target.tagName === 'INPUT') return;
    //         const input = card.querySelector('input');
    //         input.checked = !input.checked;
    //         input.dispatchEvent(new Event('change', { bubbles: true }));
    //     });
    // });
    // SIM Types
    document.querySelectorAll('.sim-option').forEach(card => {
        card.addEventListener('click', e => {
            if (e.target.tagName === 'INPUT') return;
            const input = card.querySelector('input');
            if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });



const planSection = document.querySelector('.roamlink-plans');

if (planSection) {

    const sectionHeader = planSection.querySelector('.section-heading');
    const sectionBody = planSection.querySelector('.plan-section-body');

    sectionHeader?.addEventListener('click', () => {

        const isOpen = planSection.classList.toggle('is-open');

        sectionBody.hidden = !isOpen;

        sectionHeader.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
        );

    });

}



/* ==========================================================
   DEFAULT PLAN GROUP (METAOBJECT)
========================================================== */

document.querySelectorAll('.plan-group').forEach(group => {

    const body = group.querySelector('.plan-group-body');
    const header = group.querySelector('.plan-group-header');

    if (!body || !header) return;

    const expanded =
        group.dataset.expanded === 'true';

    group.classList.toggle('is-open', expanded);
    body.hidden = !expanded;

    header.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
    );

});






    /* ==========================================================
       QUANTITY INPUT
    ========================================================== */
    if (quantityInput) {
        quantityInput.addEventListener('input', () => {
            if (quantityInput.value < 1) {
                quantityInput.value = 1;
            }
            calculateTotal();
        });
    }
    // Run on initial load
    updateSelectedCards();
    calculateTotal();
    toggleSimUI();


// Default accordion state
document.querySelector('.roamlink-plans')?.classList.add('is-open');
document.querySelector('.plan-section-body').hidden = false;
document
    .querySelector('.roamlink-plans .section-heading')
    ?.setAttribute('aria-expanded', 'true');

document.querySelector('.roamlink-sim-delivery')?.classList.remove('is-open');
document.querySelector('.sim-delivery-section-body').hidden = true;
document
    .querySelector('.roamlink-sim-delivery .section-heading')
    ?.setAttribute('aria-expanded', 'false');

document.querySelector('.roamlink-devices')?.classList.remove('is-open');
document.querySelector('.device-section-body').hidden = true;
document
    .querySelector('.roamlink-devices .device-section-heading')
    ?.setAttribute('aria-expanded', 'false');

(function () {

    const params = new URLSearchParams(window.location.search);

    const handle = params.get('plan');

    if (!handle) return;

    const planInput = document.querySelector(
        `input[data-product-handle="${handle}"]`
    );

    if (!planInput) return;

    planInput.checked = true;

    updateSelectedCards();
    calculateTotal();

})();



const topQty = document.getElementById('quantity-top');
const topMinus = document.querySelector('.qty-minus-top');
const topPlus = document.querySelector('.qty-plus-top');
const topCart = document.getElementById('roamlink-add-cart-top');

if (topQty) {
    topQty.value = quantityInput.value;
}

topMinus?.addEventListener('click', () => {
    qtyMinus.click();
    topQty.value = quantityInput.value;
});

topPlus?.addEventListener('click', () => {
    qtyPlus.click();
    topQty.value = quantityInput.value;
});

quantityInput?.addEventListener('input', () => {
    topQty.value = quantityInput.value;
});

topCart?.addEventListener('click', () => {
    addToCartBtn.click();
});








    /* ==========================================================
       ADD TO CART
    ========================================================== */
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', async () => {
            /* Required acknowledgements */
            const invalidAck = document.querySelector(
                '.acknowledgement-checkbox[required]:not(:checked)'
            );
            if (invalidAck) {
                alert('Please accept all required acknowledgements.');
                invalidAck.focus();
                return;
            }
            // SIM selector validation (mandatory if visible)
          const selectedPlan = document.querySelector(
    'input[name="roamlink-plan"]:checked'
);



const currentProductRequiresSim =
    window.roamlinkProduct.requiresSim === true;

const selectedPlanRequiresSim =
    selectedPlan
        ? selectedPlan.dataset.requiresSim === "true"
        : false;

const simRequired =
    currentProductRequiresSim || selectedPlanRequiresSim;
const checkedSim = document.querySelector(
    'input[name="properties[SIM Type]"]:checked'
);

if (simRequired && !checkedSim) {

    alert('Please choose a SIM type to continue.');

    const anchor =
        document.getElementById('sim-anchor') || simSelector;

    anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    });

    return;

}
           const qty = Math.max(
    parseInt(quantityInput?.value || 1),
    1
);

// Check if this main product is already in the cart
const cart = await fetch('/cart.js').then(r => r.json());
          /* Selected Plan */
const plan = document.querySelector(
    'input[name="roamlink-plan"]:checked'
);

const selectedSellingPlan = plan
    ? plan.dataset.sellingPlan
    : window.roamlinkProduct.sellingPlanId;



const selectedVariantId = plan
    ? Number(plan.value)
    : Number(window.roamlinkProduct.variantId);

const bundleItems = cart.items.filter(item =>
    item.properties &&
    item.properties._bundle === "roamlink"
);

// Find the existing plan item
const existingPlan = bundleItems.find(item =>
    item.product_type === "Cellular Data Plan"
);

// Same plan already in cart
if (existingPlan && existingPlan.variant_id === selectedVariantId) {

    alert("This plan is already in your cart.");
    window.location.href = "/cart";
    return;

}

// Different plan selected → remove whole bundle
for (const item of bundleItems) {

  
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: item.key,
            quantity: 0
        })
    });

}

// if (existingBundle) {

//     if (existingBundle.variant_id === selectedVariantId) {

//         alert("This plan is already in your cart.");
//         window.location.href = "/cart";
//         return;

//     }

//     // Different plan selected → remove existing bundle
//     await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             id: existingBundle.key,
//             quantity: 0
//         })
//     });

// }

            const items = [];


if (plan) {

    // Customer selected another plan
const mainItem = {
    id: Number(plan.value),
    quantity: qty,
    properties: {
        _bundle: "roamlink"
    }
};

if (selectedSellingPlan) {
    mainItem.selling_plan = Number(selectedSellingPlan);
}

items.push(mainItem);
} else {

    // No plan selected, use current PDP plan
 const mainItem = {
    id: Number(window.roamlinkProduct.variantId),
    quantity: qty,
    properties: {
        _bundle: "roamlink"
    }
};

if (selectedSellingPlan) {
    mainItem.selling_plan = Number(selectedSellingPlan);
}

items.push(mainItem);

}
            /* Selected Device */
            const device = document.querySelector(
                'input[name="roamlink-device"]:checked'
            );
           if (device && Number(device.value) > 0) {
    items.push({
        id: Number(device.value),
        quantity: qty,
        properties: {
            _bundle: "roamlink"
        }
    });
}
               
            /* Addons */
            document.querySelectorAll(
                'input[name="roamlink-addon"]:checked'
            ).forEach(addon => {
                items.push({
                    id: Number(addon.value),
                    quantity: qty,
                     properties: {
        _bundle: "roamlink"
    }
                });
            });
            /* Selected SIM Product Addon */
           if (simRequired && checkedSim)  {
               let simVariantId = null;

switch (checkedSim.value.trim()) {

    case 'eSIM':
        simVariantId = ROAMLINK_SIM_VARIANTS.esim;
        break;

    case 'Physical SIM':
        simVariantId = ROAMLINK_SIM_VARIANTS.physical;
        break;
}
                if (simVariantId) {
                    items.push({
                        id: simVariantId,
                        quantity: qty,
                         properties: {
        _bundle: "roamlink",
        "SIM Type": checkedSim.value.trim()
    }
                    });
                }
            }
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Adding...';
            try {
        console.table(items);
console.log("Selected plan:", plan);
console.log("Main variant:", window.roamlinkProduct.variantId);
              const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
});

const result = await response.json();

console.log("Status:", response.status);
console.log("Response:", result);

if (!response.ok) {
    throw new Error(result.description || "Cart error");
}
                const miniCart = document.querySelector('mini-cart');

if (miniCart) {
    const sections = miniCart.getSectionsToRender().map(section => section.section);

    const sectionsResponse = await fetch(
        `/cart?sections=${sections.join(',')}`
    );

    const parsedState = {
        id: result.items[0].id,
        sections: await sectionsResponse.json()
    };

    miniCart.renderContents(parsedState);
}
            }
           catch (e) {
    console.error(e);
    alert(e.message);
}
            finally {
                addToCartBtn.disabled = false;
                addToCartBtn.textContent = 'Add to Cart';
            }
        });
    }





/* ==========================================================
   SIM ACCORDION
========================================================== */

const simSection = document.querySelector('.roamlink-sim-delivery');

if (simSection) {

    const simHeading = simSection.querySelector('.section-heading');
    const simBody = simSection.querySelector('.sim-delivery-section-body');

    simHeading?.addEventListener('click', () => {

        const isOpen = simSection.classList.toggle('is-open');

        simBody.hidden = !isOpen;

        simHeading.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
        );

    });

}



/* ==========================================================
   DEVICE ACCORDION
========================================================== */

const deviceSection = document.querySelector('.roamlink-devices');

if (deviceSection) {

    const deviceHeading = deviceSection.querySelector('.device-section-heading');
    const deviceBody = deviceSection.querySelector('.device-section-body');

    deviceHeading?.addEventListener('click', () => {

        const isOpen = deviceSection.classList.toggle('is-open');

        deviceBody.hidden = !isOpen;

        deviceHeading.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
        );

    });

}




});
